import { Outlet } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import '../layouts/rootLayout.css'

function RootLayout() {
  return (
    <>
      <Navbar />
      <div className='navbar-spacer'></div>
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  )
}

export default RootLayout